import Loader from '@/components/Loader/Loader'
import { AuthService } from '@/services/auth.service'
import { useQuery } from '@tanstack/react-query'
import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import {
  getContractRedirectTarget,
  getReturnToFromContract,
} from '@/auth/contractRedirect'

type RequireContractSignedProps = {
  children: React.ReactNode
}

export function RequireContractSigned({
  children,
}: RequireContractSignedProps) {
  const location = useLocation()

  const { data: userInfo, isPending } = useQuery({
    queryKey: ['user-info'],
    queryFn: async () => await AuthService.userInfo(),
    staleTime: 1000 * 60 * 60 * 24,
  })

  if (isPending) {
    return (
      <div className="flex items-center justify-center w-full h-screen">
        <Loader />
      </div>
    )
  }

  const contractRedirectTo = getContractRedirectTarget(location, userInfo)
  if (contractRedirectTo) {
    return <Navigate to={contractRedirectTo} replace />
  }

  const isSigned = userInfo?.contract_signed === true
  if (isSigned) {
    const returnTo = getReturnToFromContract(location)
    if (returnTo) return <Navigate to={returnTo} replace />
  }

  return <>{children}</>
}
